/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Materialclosetowneriscw5Inputs */

const de__field_materialclosetowneriscw5 = /** @type {(inputs: _Field_Materialclosetowneriscw5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materialschrank gehöhrt CHANCENwerk`)
};

/**

* @param {_Field_Materialclosetowneriscw5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_materialclosetowneriscw5 = /** @type {((inputs?: _Field_Materialclosetowneriscw5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Materialclosetowneriscw5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_materialclosetowneriscw5(inputs)
});
export { _field_materialclosetowneriscw5 as "_field_materialClosetOwnerIsCW" }